import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StopPropagationModule } from '@portal-core/general/directives/stop-propagation/stop-propagation.module';
import { GridHeaderFilterFormModule } from '@portal-core/ui/grid/directives/grid-header-filter-form/grid-header-filter-form.module';
import { GridHeaderFilterMenuModule } from '@portal-core/ui/grid/directives/grid-header-filter-menu/grid-header-filter-menu.module';
import { GridHeaderFilterComponent } from './grid-header-filter.component';

@NgModule({
  declarations: [
    GridHeaderFilterComponent
  ],
  imports: [
    A11yModule,
    CommonModule,
    GridHeaderFilterFormModule,
    GridHeaderFilterMenuModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSortModule,
    MatTooltipModule,
    StopPropagationModule
  ],
  exports: [
    GridHeaderFilterComponent
  ]
})
export class GridHeaderFilterModule { }
